import { ChangeDetectionStrategy, Component, ElementRef, inject, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
//import eventcreatemodel from '../../../../../shared/models/eventcreatemodel';
import { ApiService } from '../../../../../shared/services/api.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//import { District } from '../../../../../shared/models/district.model';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';
import { DatePipe } from '@angular/common';
import { dE, el } from '@fullcalendar/core/internal-common';
import { StorageService } from '../../../../../shared/services/storage.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { IDropdownSettings } from 'ng-multiselect-dropdown';
export interface DropdownItem {
  item_id: number;
  item_text: string;
}


@Component({
  selector: 'app-iaeventcreate',
  templateUrl: './iaeventcreate.component.html',
  styleUrl: './iaeventcreate.component.css',
  providers: [DatePipe]
})


export class IaeventcreateComponent implements OnInit {

  registrationForm: FormGroup;
  isSubmitted = false;
  isAdd = false;
  trainerData: any[] = [];
  spocData: any[] = [];
  @ViewChild('dropdown') dropdown!: ElementRef;

  eventOrganizationText: any;
  districText: any;
  cityText: any;
  townText: any;
  eventFocusText: any;
  interventionText: any;
  typeOfComponentText: any;
  visibleTable = false;
  visibleSPOCTable = false;
  selectedDistricId: any;
  selectedDistricText: string = '';
  selectedCityId: any;
  selectedCityText: string = '';
  selectedTownId: any;
  selectedTownText: string = '';
  components: any[] = [];
  eventorganisedby: any = [];
  period: any = [];
  focussector: any = [];
  intervention: any = [];
  typeComponent: any = [];
  district: any = [];
  city: any = [];
  cityData: any = [];
  townData: any = [];
  trainerCityData: any = [];
  trainerTownData: any = [];
  districtsBasedOnState: any[] = [];
  implementationAgencyName: any;
  dropdownList: any = [];
  selectedItems: any = [];
  dropdownSettings: any = {};
  txtButton: string = 'Submit';
  proposalUserId: any;
  UniqueEventId: any;
  action: any;
  data: any = {};
  showButton: boolean = true;
  showCancelButton: boolean = false;
  eventDate: Date = new Date(); // Example event date
  isDropdownDisabled = false;  // Flag to control whether the dropdown is disabled
minDate: Date = new Date(2025, 3, 1);
  maxDate: any;
  eventName: any;
  eventOriginalDate: any;
  startDateTime: Date | null = null;
  formattedTime: string | null = null; // To hold formatted time value
  isRemarksRequired: boolean = false;
  maxSitingCapacity: any;
  minTime: string = '';
  balanceTargetMSME: any;
  holdSeatingCapacity: any;
  eventDateTime: Date = new Date();
  message: string = '';
  eventQriginalTime: any;
  eventOriginalDurationOfEvent: any;
  eventOriginalPeriod: any;

  originalData: any = [];

  constructor(private apiService: ApiService, private storageService: StorageService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private toastrService: ToastrService, private commonService: CommonService, private datePipe: DatePipe) {

    this.registrationForm = this.fb.group({
      eventOrganizedBy: [null, Validators.required],
      implementationAgency: [{ value: '', disabled: true }],
      eventName: ['', [
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(/^[^&]+$/)
        //Validators.pattern('^[A-Za-z]+([ ]?[A-Za-z]+)*$'),
        //Validators.pattern(/^[A-Za-z]+( [A-Za-z]+)*$/)
        //Validators.pattern(this.commonService.nameWithSpacePattern)
      ]
      ],
      eventDateTime: ['', Validators.required],
      eventStartTime: ['', Validators.required],
      durationEvent: ['', Validators.required],
      period: [null, Validators.required],
      distric: [null, Validators.required],
      //city: [{ value: '', disabled: true }, Validators.required],
      //townblock: [{ value: '', disabled: true }, Validators.required],
      city: [null, Validators.required],
      townblock: [null, Validators.required],
      village: ['', [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(this.commonService.stringWithSpacePattern)
      ]],
      venueDetails: ['', [
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(/^[^&]+$/)
        //Validators.pattern(this.commonService.addressPattern)
      ]],
      sittingCapacity: ['', [
        Validators.required,
        Validators.min(1),
        Validators.maxLength(50),
      ]],
      eventFocusSector: [null, Validators.required],
      //intervention: ['', Validators.required],
      intervention: [{ value: '', disabled: true }, Validators.required],
      //typeComponent: ['', Validators.required],
      typeComponent: [{ value :'', disabled: true }, Validators.required],
      trainerName: ['', [
        Validators.required,
        Validators.maxLength(200),
        Validators.pattern(this.commonService.stringWithSpacePattern)
      ]],
      trainerCompanyName: ['', [
        Validators.required,
        Validators.maxLength(200),
        Validators.pattern(this.commonService.stringWithSpacePattern)
      ]],
      contactNumber: ['', [
        Validators.required,
        Validators.pattern(/^([6789]\d{9})$/),
        Validators.maxLength(10),
        Validators.pattern(/^\d{10}$/)
      ]],
      districtId: [null, Validators.required],
      cityId: [null, Validators.required],
      townId: [null, Validators.required],
      spoc: ['', Validators.required],
      status: [null],
      remarks: [],
      hiddenValue: [0],
      //eventDateTime1:['']
    });


  }
  get f() {
    return this.registrationForm.controls;
  }

  numberOnly(event: KeyboardEvent): void {
    const charCode = event.keyCode || event.which;
    if (charCode < 48 || charCode > 57) {
      // Allow only numbers
      event.preventDefault();
    }
  }


  async LoadDetails(eventId: string): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETIAEventDetail, { UniqueEventId: eventId }).subscribe(
      result => {

        if (result.status) {
          //var interventionId = result.data['item1']?.intervention;
          //var typeOfcomponent = result.data['item1']?.typeComponent;
          //this.onSelectInterventionChange(interventionId, 'edit');

          var distId = result.data['item1']?.distric;
          this.eventDate = result.data['item1']?.eventDateTime.split('T')[0];

          delete result.data.item1.spoc;
          this.onSelectDistricChange(distId, 'edit');
          this.eventName = result.data['item1']?.eventName;

          this.districText = result.data['item1']?.districtName;
          this.cityText = result.data['item1']?.cityName;
          this.townText = result.data['item1']?.blockName;
          this.interventionText = result.data['item1']?.interventionName;
          this.typeOfComponentText = result.data['item1']?.interestName;

          


          this.registrationForm.patchValue(result.data['item1']);
          

          var date = result.data['item1']?.eventDateTime.split('T')[0];
          var time = result.data['item1']?.eventDateTime.split('T')[1];
          var date1 = new Date(date);
          this.registrationForm.get('eventDateTime')?.setValue(date1);
          this.registrationForm.get('eventStartTime')?.setValue(time);

          this.eventOriginalDate = result.data['item1']?.eventDateTime;
          this.eventQriginalTime = time;
          this.eventOriginalDurationOfEvent = result.data['item1']?.durationEvent;
          this.eventOriginalPeriod = result.data['item1']?.period;

          this.originalData = {
            eventOrganizedBy: result.data['item1']?.eventOrganizedBy,
            eventDateTime: date1,
            eventStartTime: time,
            durationEvent: result.data['item1']?.durationEvent,
            period: result.data['item1']?.period,
            venueDetails: result.data['item1']?.venueDetails,
            eventFocusSector: result.data['item1']?.eventFocusSector,
            sittingCapacity: result.data['item1']?.sittingCapacity,
          }
       
          this.maxSitingCapacity = Math.min(
            Number(this.balanceTargetMSME) + Number(result.data?.item1?.sittingCapacity ?? 0),
            Number(this.holdSeatingCapacity ?? 0)
          );
          
          this.registrationForm.get('status')?.setValue(null)
          this.registrationForm.get('remarks')?.setValue('');

          var spoc = result.data['item3'];

          var spocdata: any = [];

          for (var i = 0; i < spoc.length; i++) {
            // Push a new object to the spocdata array
            spocdata.push({
              "id": spoc[i]?.id,
              "text": spoc[i]?.spocName
            });

            this.spocData.push({
              "PersonName": spoc[i]?.spocName,
              "MobileNumber": spoc[i]?.spocMobile,
              "EmailId": spoc[i]?.spocEmail
            });
          }
          if (this.spocData.length > 0)
            this.visibleSPOCTable = true;

          this.registrationForm.patchValue({
            spoc: spocdata
          });

          for (let i = 0; i < result.data['item2'].length; i++) {
            var object = {
              "id": result.data['item2'][i]['id'],
              "trainerName": result.data['item2'][i]['trainerName'],
              "trainerCompanyName": result.data['item2'][i]['trainerCompanyName'],
              "contactNumber": result.data['item2'][i]['contactNumber'],
              "districtId": String(result.data['item2'][i]['districtId']),
              "districText": result.data['item2'][i]['districtName'],
              "cityId": String(result.data['item2'][i]['cityId']),
              "cityText": result.data['item2'][i]['cityName'],
              "townId": String(result.data['item2'][i]['blockId']),
              "townText": result.data['item2'][i]['blockName'],
            }
            this.trainerData.push(object);
          }

          if (this.trainerData)
            this.visibleTable = true;

          //setTimeout(() => {
          //this.registrationForm.controls['status'].setValue(null);
          this.registrationForm.controls['eventOrganizedBy'].setValue(result.data['item1']?.eventOrganizedBy.toString());

          this.registrationForm.controls['distric'].setValue(distId.toString());
          this.registrationForm.controls['city'].setValue(result.data['item1']?.city.toString());
          this.registrationForm.controls['townblock'].setValue(result.data['item1']?.townblock.toString());
          this.registrationForm.controls['eventFocusSector'].setValue(result.data['item1']?.eventFocusSector.toString());

          this.registrationForm.controls['intervention'].setValue(result.data['item1']?.intervention.toString());
          this.registrationForm.controls['typeComponent'].setValue(result.data['item1']?.typeComponent.toString());

          //this.registrationForm.controls['districtId'].setValue(result.data['item1']?.districtId);
          //this.registrationForm.controls['cityId'].setValue(result.data['item1']?.cityId);
          //  this.registrationForm.controls['townId'].setValue(result.data['item1']?.townId);
          //}, 2000); // Waits 2 seconds before execution

          this.checkEventDateAndDisableControls();
          
        }
      }
    )
  }

  ngOnInit() {

    this.period = [
      { id: 'Hours', text: 'Hours' },
      { id: 'Days', text: 'Days' }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'text',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };

    const ul = document.querySelector('ng-multiselect-dropdown .item1');
    if (ul) {
      ul.remove();  // Removes the <ul> element from the DOM
    }

    this.getIAEventSelectList();

    //this.setMinTime();

  }

  onEdit(id: any) {
    
    sessionStorage.setItem('editId', id);
    const trainer = this.getDataById(id);

    this.onTrainerDistricEdit(trainer?.districtId);

    sessionStorage.setItem('districtText', trainer?.districText);
    sessionStorage.setItem('cityText', trainer?.cityText);
    sessionStorage.setItem('townText', trainer?.townText);

    this.registrationForm.patchValue({
      hiddenValue: id,
      trainerName: trainer?.trainerName,
      trainerCompanyName: trainer?.trainerCompanyName,
      contactNumber: trainer?.contactNumber,
      districtId: trainer?.districtId,
      cityId: trainer?.cityId,
      townId: trainer?.townId
    });

    // Remove trainer details by id
    this.removeTrainerById(id);
    //this.trainerData = this.trainerData.filter(trainerName => trainerName.trainerName !== id);
  }

  getDataById(id: number) {
    
    const item = this.trainerData.find((item: any) => item.id === id);
    return item;
  }

  onSelectEventOrganizedChange(event: any) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedIndex = selectElement.selectedIndex;
    this.eventOrganizationText = selectElement.options[selectedIndex].text;
  }

  onSelectEventFocusChange(event: any) {
    //const selectElement = event.target as HTMLSelectElement;
    //const selectedIndex = selectElement.selectedIndex;
    this.eventFocusText = event.text;
  }

  onSOCSelect(item: any) {

    var selectedValue = this.selectedItems;
    var data = { spocId: item.id }

    this.apiService.getRequest(API_ENDPOINTS.IA.GETSPOCDETAILS, data).subscribe(
      (result: any) => {

        var obj = {
          "Id": result.data[0]['Id'],
          "PersonName": result.data[0]['PersonName'],
          "MobileNumber": result.data[0]['MobileNumber'],
          "EmailId": result.data[0]['EmailId']
        }
        this.spocData.push(obj);

        //this.spocData = result.data;
        this.visibleSPOCTable = true;
      },
      error => {
        console.error('Error fetching data:', error);
      }
    );

    ////
    //if (this.selectedItems.length >2) {
    //  // Limit reached, deselect the item
    //  this.selectedItems.pop(); // Remove the last selected item
    //  alert('You can only select up to 3 items.');

    //  //this.selectedItems = []; // Clear selected items
    //} else {
    //  this.selectedItems.push(item);
    //}
  }

  onSOCDeSelect(item: any) {


    if (!item || !item.text) {
      console.error("Item or item.text is invalid.");
      return;
    }

    const text = item.text;

    // Find the index of the object with matching text
    const index = this.spocData.findIndex((dataItem: any) => dataItem.PersonName === text);

    if (index !== -1) {
      // Remove the item at the found index
      this.spocData.splice(index, 1);
      //console.log(`Item with text "${text}" removed from spocData.`);
    } else {
    }

    // Check if spocData is empty and hide the table if true
    if (this.spocData.length === 0) {
      this.visibleSPOCTable = false;
    }
  }

  async getIAEventSelectList(): Promise<void> {

    this.route.params.subscribe(params => {
      this.proposalUserId = params['proposaluserid'];
    });


    //const { param1, param2 } = this.storageService.getTwoParams();
    //if (param1 && param2) {
    //  // Store the parameters in sessionStorage
    //  sessionStorage.setItem('param1', param1);
    //  sessionStorage.setItem('param2', param2);
    //}
    //this.proposalUserId = sessionStorage.getItem('param2');

    //var userId = sessionStorage.getItem("industryAssociationUserId");
    var data = { proposalUserId: this.proposalUserId }
    
    this.apiService.getRequest(API_ENDPOINTS.IA.GETIACREATEEVENT, data).subscribe(
      (result: any) => {
        this.eventorganisedby = result.eventOrganisedList;
        if (result.eventOrganisedList[0]['text'] == "MSSIDC")       
          this.implementationAgencyName = result.eventOrganisedList[1]['text'];
        else
          this.implementationAgencyName = result.eventOrganisedList[0]['text'];
        this.focussector = result.focusSectorList;
        this.intervention = result.interestList;
        this.typeComponent = result.interventionList;
        this.registrationForm.controls['intervention'].setValue(this.intervention[0]['id'].toString());
        this.interventionText = this.intervention[0]['text'],
        this.registrationForm.controls['typeComponent'].setValue(this.typeComponent[0]['id'].toString());
        this.typeOfComponentText = this.typeComponent[0]['text']


        
        this.district = result.districtList;
        this.dropdownList = result.industryAssociationList;


        var proposalDate = result?.proposalDateRange.split("##");

        //added by rounak
        //this.maxSitingCapacity = result?.seatingCapacity; // Commented by rounak 23Sept2025
        
        this.balanceTargetMSME = result?.balanceTargetMSME;
        this.holdSeatingCapacity = result?.seatingCapacity ?? 0;


        // Added by rounak 23Sept2025
        //Angular/TypeScript correction would be:
        //if (this.balanceTargetMSME >= result?.seatingCapacity) {
        //  this.maxSitingCapacity = result?.seatingCapacity ?? 0;
        //} else {
        //  this.maxSitingCapacity = result?.balanceTargetMSME ?? 0;
        //}
        //this.balanceTargetMSME = 500;
        //Even shorter (ternary operator):



        this.maxSitingCapacity = Math.min(
          + this.balanceTargetMSME || 0,
          +(this.holdSeatingCapacity ?? 0)
        );


        //this.maxSitingCapacity =
        //  Number(this.balanceTargetMSME) < Number(result?.seatingCapacity ?? 0)
        //    ? Number(this.balanceTargetMSME)
        //    : Number(result?.seatingCapacity ?? 0);
        //this.maxSitingCapacity =
        //  this.balanceTargetMSME >= (result?.seatingCapacity ?? 0)
        //    ? (result?.seatingCapacity ?? 0)
        //    : (result?.balanceTargetMSME ?? 0);
        //rounak ends

        //this.minDate = proposalDate[0] + 'T00:00';
        //this.maxDate = proposalDate[1] + 'T23:59';


        // Initialize the form
        const min = new Date(proposalDate[0]);
        const max = new Date(proposalDate[1]);
        const currentDate = new Date();


        // if (min < currentDate) {
        //   this.minDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
        // } else {
        //   this.minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());
        // }

        //this.minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());
        this.maxDate = new Date(max.getFullYear(), max.getMonth(), max.getDate());

        //this.minDate = '2024-12-0T00:00';
        //this.maxDate = '2024-12-15T23:59';

        //this.registrationForm = this.fb.group({
        //  distric: [null]  // Reactive form control for the district dropdown
        //});

        

        //this.registrationForm.controls['period'].setValue(null);
        //this.registrationForm.controls['distric'].setValue(null);
        //this.registrationForm.controls['city'].setValue(null); 
        //this.registrationForm.controls['townblock'].setValue(null);
        //this.registrationForm.controls['eventFocusSector'].setValue(null);

        //this.registrationForm.controls['intervention'].setValue(null);
        //this.registrationForm.controls['typeComponent'].setValue(null);

        //this.registrationForm.controls['districtId'].setValue(null);
        //this.registrationForm.controls['cityId'].setValue(null);
        //this.registrationForm.controls['townId'].setValue(null);

        this.route.params.subscribe(params => {

          this.UniqueEventId = params['eventid'];
          if (this.UniqueEventId) {
            //this.action = true;
            this.txtButton = "Update"
            this.LoadDetails(this.UniqueEventId);
          }

        });

        //if (sessionStorage.getItem('param1')) {
        //  this.UniqueEventId = sessionStorage.getItem('param1');
        //  if (this.UniqueEventId) {
        //    //this.action = true;
        //    this.txtButton = "Update"
        //    this.LoadDetails(this.UniqueEventId);
        //  }
        //}

      },
      error => {
        console.error('Error fetching data:', error);
      }
    );
  }

  allOptions = [
    /*{ value: '', label: '--select--' },*/
    { value: 'created', label: 'Update' },
    { value: 'postpone', label: 'Postpone' },
    { value: 'cancel', label: 'Cancel' }
  ];

  // Filtered options based on condition
  filteredOptions = [...this.allOptions];




  removeOptions() {


    this.filteredOptions = [...this.allOptions];

    const currentDate = this.convertDateToYYYYMMDD(this.registrationForm.get('eventDateTime')?.value);
    const currentStartTime = this.registrationForm.get('eventStartTime')?.value;
    const currentDuration = this.registrationForm.get('durationEvent')?.value;
    const currentPeriod = this.registrationForm.get('period')?.value;

    const isDateChanged = this.eventOriginalDate.split('T')[0] !== currentDate;
    const isTimeChanged = this.eventQriginalTime !== currentStartTime;
    const isDurationChanged = this.eventOriginalDurationOfEvent !== currentDuration.toString();
    const isPeriodChanged = this.eventOriginalPeriod !== currentPeriod;

    if (isDateChanged || isTimeChanged || isDurationChanged || isPeriodChanged) {
      // If any field has changed, show only "select" and "postpone"
      this.filteredOptions = this.allOptions.filter(option => option.value !== 'created' && option.value !== 'cancel');
    }
    //else {
    //  // If nothing has changed, remove "postpone" and keep others
    //  this.filteredOptions = this.allOptions.filter(option => option.value !== 'postpone');
    //}
  }



  //removeOption() {


  //  this.filteredOptions = [...this.allOptions];

  //  var currentDate = this.convertDateToYYYYMMDD(this.registrationForm.get('eventDateTime')?.value)
  //  //this.setMinTime();
  //  if (this.eventOriginalDate.split('T')[0] === currentDate || this.eventQriginalTime == this.registrationForm.get('eventStartTime')?.value || this.eventOriginalDurationOfEvent == this.registrationForm.get('durationEvent')?.value || this.eventOriginalPeriod == this.registrationForm.get('period')?.value) {
  //    // If the dates are the same, remove "postpone" option
  //    this.filteredOptions = this.allOptions.filter(option => option.value !== 'postpone');
  //  } else {
  //    // If the dates are different, remove "created" and "cancel" options
  //    this.filteredOptions = this.allOptions.filter(option => option.value !== 'created' && option.value !== 'cancel');
  //  }


  //}

  convertDateToYYYYMMDD(date: Date): string {
    this.eventDateTime = date;
    const adjustedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()); // Create a date ignoring time zone
    const year = adjustedDate.getFullYear();
    const month = String(adjustedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(adjustedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }




  // Add trainer data in datatable
  AddTrainer() {

    this.isAdd = true;


    ////this.isSubmitted = true;  // Show errors for Trainer details only
    //if (this.registrationForm.get('trainerName')!.invalid ||
    //  this.registrationForm.get('trainerCompanyName')!.invalid ||
    //  this.registrationForm.get('contactNumber')!.invalid ||
    //  this.registrationForm.get('districtId')!.invalid ||
    //  this.registrationForm.get('cityId')!.invalid ||
    //  this.registrationForm.get('townId')!.invalid) {
    //  this.resetValidation();
    //  return;
    //}

    const trainerNameControl = this.registrationForm.get('trainerName');
    const trainerCompanyNameControl = this.registrationForm.get('trainerCompanyName');
    const contactNumberControl = this.registrationForm.get('contactNumber');
    const districtIdControl = this.registrationForm.get('districtId');
    const cityIdControl = this.registrationForm.get('cityId');
    const townIdControl = this.registrationForm.get('townId');

    if (trainerNameControl) {
      trainerNameControl.setValidators([Validators.required, Validators.maxLength(200), Validators.pattern(this.commonService.stringWithSpacePattern)]); // Set validators dynamically
      trainerNameControl.updateValueAndValidity(); // Recalculate validity
    }
    if (trainerCompanyNameControl) {
      trainerCompanyNameControl.setValidators([Validators.required, Validators.maxLength(200), Validators.pattern(this.commonService.stringWithSpacePattern)]);
      trainerCompanyNameControl.updateValueAndValidity();
    }
    if (contactNumberControl) {
      contactNumberControl.setValidators([Validators.required, Validators.pattern(/^([6789]\d{9})$/), Validators.maxLength(10), Validators.pattern(/^\d{10}$/)]);
      contactNumberControl.updateValueAndValidity();
    }
    if (districtIdControl) {
      districtIdControl.setValidators([Validators.required]);
      districtIdControl.updateValueAndValidity();
    }
    if (cityIdControl) {
      cityIdControl.setValidators([Validators.required]);
      cityIdControl.updateValueAndValidity();
    }
    if (townIdControl) {
      townIdControl.setValidators([Validators.required]);
      townIdControl.updateValueAndValidity();
    }


    if (this.trainerData.length < 4) {

      
      if (this.registrationForm.controls['trainerName'].value != "" && this.registrationForm.controls['trainerCompanyName'].value != "" && this.registrationForm.controls['contactNumber'].value != "" && this.selectedDistricId != "" && sessionStorage.getItem('districtText') != "" && this.registrationForm.controls['cityId'].value != null && sessionStorage.getItem('cityText') != null && this.registrationForm.controls['townId'].value != null && sessionStorage.getItem('townText') != null) {
        //

        var object = {
          "id": this.registrationForm.controls['hiddenValue'].value,
          "trainerName": this.registrationForm.controls['trainerName'].value,
          "trainerCompanyName": this.registrationForm.controls['trainerCompanyName'].value,
          "contactNumber": String(this.registrationForm.controls['contactNumber'].value),
          "districtId": this.registrationForm.controls['districtId'].value,//this.selectedDistricId,
          "districText": sessionStorage.getItem('districtText'),
          "cityId": this.registrationForm.controls['cityId'].value,
          "cityText": sessionStorage.getItem('cityText'),//  this.selectedCityText,
          "townId": this.registrationForm.controls['townId'].value,
          "townText": sessionStorage.getItem('townText'),
        }

        // Check if the trainer name already exists in trainerData
        if (this.trainerData.some(trainer => trainer.trainerName === this.registrationForm.controls['trainerName'].value)) {
          //alert('This trainer is already registered.');
          this.toastrService.error("error", "This trainer is already registered.");
          return;
        } else {
          // Proceed with form submission (e.g., send to backend)
          this.trainerData.push(object);
          this.showCancelButton = true;
          this.visibleTable = true;
          this.registrationForm.get('hiddenValue')?.setValue(0);  // Reset hidden field value

          // Reset the entire form to null
          this.registrationForm.get('trainerName')?.setValue('');
          this.registrationForm.get('trainerCompanyName')?.setValue('');
          this.registrationForm.get('contactNumber')?.setValue('');
          this.registrationForm.get('districtId')?.setValue('');
          this.registrationForm.get('cityId')?.setValue('');
          this.registrationForm.get('townId')?.setValue('');

          this.selectedDistricId = "";
          sessionStorage.removeItem('districtText');
          sessionStorage.removeItem('cityText')
          sessionStorage.removeItem('townText')

          this.ignoreNameValidation();

          //this.registrationForm.reset({
          //  trainerName: null,
          //  trainerCompanyName: null,
          //  contactNumber: null,
          //  districtId: '',
          //  cityId: '',
          //  townId:''
          //});
          //this.ignoreNameValidation();

        }
        this.trainerData = [...this.trainerData]; // Create a new reference
        this.registrationForm.controls['districtId'].setValue(null);
        this.registrationForm.controls['cityId'].setValue(null);
        this.registrationForm.controls['townId'].setValue(null);
      }

    } else {
      //alert('Array length cannot exceed 4 items.');
      this.toastrService.error("error", "cannot add more than 4");
      return;
    }

    //var object = {
    //  "trainerName": this.registrationForm.controls['trainerName'].value,
    //  "trainerCompanyName": this.registrationForm.controls['trainerCompanyName'].value,
    //  "contactNumber": this.registrationForm.controls['contactNumber'].value,
    //  "districtId": this.selectedDistricId,
    //  "districText": sessionStorage.getItem('districtText'),
    //  "cityId": this.registrationForm.controls['cityId'].value,
    //  "cityText": sessionStorage.getItem('cityText'),//  this.selectedCityText,
    //  "townId": this.registrationForm.controls['townId'].value,
    //  "townText": sessionStorage.getItem('townText'),
    //}

    //if (this.trainerData && this.trainerData.length < 4) {
    //  this.trainerData.some(trainer => trainer.trainerName === this.registrationForm.controls['trainerName'].value);
    //  this.toastrService.error('Already exist');
    //  return;
    //};

    //// Check if the trainer name already exists in trainerData
    //if (this.trainerData.some(trainer => trainer.trainerName === this.registrationForm.controls['trainerName'].value)) {
    //  //alert('This trainer is already registered.');
    //  this.toastrService.error("error","This trainer is already registered.");
    //  return;
    //} else {
    //  // Proceed with form submission (e.g., send to backend)
    //}

    //if (object.trainerName != '' && object.trainerCompanyName != '' && object.contactNumber != '' && object.districtId != '' && object.districText != '' && object.cityId != '' && object.cityText != '' && object.townId != '' && && object.townText != '')
    //  this.trainerData.push(object);

    //if (object.trainerName)
    //  this.trainerData.push(object);

    //if (this.trainerData[0].trainerName != "" && this.trainerData[0].trainerCompanyName != "" && this.trainerData[0].contactNumber != "" && this.trainerData[0].districtId != "" && this.trainerData[0].cityId != "" && this.trainerData[0].townId != "") {
    //  this.visibleTable = true;
    //}
    //  this.trainerData = [...this.trainerData]; // Create a new reference
  }

  // Remove Validation and clear value
  RemoveValidation() {

    this.ignoreNameValidation();
    this.registrationForm.get('trainerName')?.setValue('');
    this.registrationForm.get('trainerCompanyName')?.setValue('');
    this.registrationForm.get('contactNumber')?.setValue('');
    this.registrationForm.get('districtId')?.setValue(null);
    this.registrationForm.get('cityId')?.setValue(null);
    this.registrationForm.get('townId')?.setValue(null);
    
  }

  // Data delete from table
  onRemove(val: any) {

    this.trainerData = this.trainerData.filter(trainerName => trainerName.trainerName !== val);
    if (this.trainerData.length == 0)
      this.visibleTable = false;
  }

  // Create a new array excluding the trainer with the matching id
  removeTrainerById(id: number) {
    this.trainerData = this.trainerData.filter(trainer => trainer.id !== id);
  }

  // DropDown distric change
  onSelectDistricChange(item: any, action: any) {
    var distId;
    if (action == 'select') {
      // const selectElement = item.target as HTMLSelectElement;
      //const selectedIndex = selectElement.selectedIndex;
      distId = item.id;
      this.districText = item.text;
    }


    if (action == 'edit') {
      distId = item;
    }

    var data = { DistrictId: distId }

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.DISTRICT.GETCITYBLOCK, data).subscribe(
      (result: any) => {

        this.cityData = result.data['item1'];
        this.townData = result.data['item2'];

        // Reset city and enable the dropdown
        //this.registrationForm.get('city')?.setValue('');
        //this.registrationForm.get('city')?.enable();

        // Mark city as untouched to show validation if needed
        //this.registrationForm.get('city')?.markAsUntouched();

      },
      error => {
        console.error('Error fetching data:', error);
      }
    );
  }

  // DropDown period change
  onSelectPeriodChange(item: any) {
    
    //alert(item.target.value);
    if (item.text == "Days") {

      var days = this.registrationForm.get('durationEvent')?.value;
      var selectedDate = this.registrationForm.get('eventDateTime')?.value;//.split('T')[0];

      const actualDateString = this.addDays(selectedDate, days);
      //const actualDate = this.datePipe.transform(actualDateString, 'yyyy-MM-dd')!;
      var isCheck: boolean;
      isCheck = this.isDateBetween(new Date(actualDateString), this.minDate, this.maxDate)
      if (!isCheck) {
        this.registrationForm.get('eventDateTime')?.reset();
        this.registrationForm.get('durationEvent')?.reset();
        this.registrationForm.get('period')?.setValue('');
        this.toastrService.error('error', 'Date range is invalid');
      }

    }

    this.removeOptions();
  }

  // Function to add number of days to a selected date and return it in yyyy-MM-dd format
  addDays(date: Date, days: number): string {
    const newDate = new Date(date);  // Create a new date object
    newDate.setDate(newDate.getDate() + days);  // Add the specified number of days

    // Format the new date to yyyy-MM-dd
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, '0');  // Months are 0-based, so add 1
    const day = String(newDate.getDate()).padStart(2, '0');  // Pad single digits to ensure 2 digits

    return `${year}-${month}-${day}`;  // Return in yyyy-MM-dd format
  }

  // Function to check if a date is within a given range (between minDate and maxDate)
  isDateBetween(dateToCheck: Date, minDate: Date, maxDate: Date): boolean {
    // Convert the dateToCheck to 'yyyy-MM-dd' string
    const dateFormatted = this.datePipe.transform(dateToCheck, 'yyyy-MM-dd');

    // Make sure to handle possible null/undefined values for the dates
    if (dateFormatted && minDate && maxDate) {
      // Convert minDate and maxDate to 'yyyy-MM-dd' formatted strings
      const minDateFormatted = this.datePipe.transform(minDate, 'yyyy-MM-dd');
      const maxDateFormatted = this.datePipe.transform(maxDate, 'yyyy-MM-dd');

      // Compare if the dateToCheck is greater than or equal to minDate, and less than or equal to maxDate
      return dateFormatted >= minDateFormatted! && dateFormatted <= maxDateFormatted!;
    }

    return false; // Return false if any date is invalid
  }

  // Method to reset the eventDateTime control when blur is triggered
  onBlurReset() {
    //this.registrationForm.get('durationEvent')?.reset(); // Reset the form control

    this.removeOptions();
    //this.setMinTime();
  }

  // Method to reset the period control when blur is triggered
  onBlurResetPeriod() {
    //this.registrationForm.get('period')?.setValue(''); // Reset the form control

    if (this.eventOriginalDurationOfEvent == this.registrationForm.get('durationEvent')?.value) {
      this.filteredOptions = this.allOptions.filter(option => option.value !== 'postpone');
    } else {
      // If the dates are different, remove "created" and "cancel" options
      this.filteredOptions = this.allOptions.filter(option => option.value !== 'created' && option.value !== 'cancel');
    }

    this.removeOptions();

  }

  // DropDown city change
  onSelectCityChange(item: any) {
    
    //const selectElement = item.target as HTMLSelectElement;
    //const selectedIndex = selectElement.selectedIndex;
    this.cityText = item.text;

    // Reset city and enable the dropdown
    //this.registrationForm.get('townblock')?.setValue('');
    this.registrationForm.get('townblock')?.enable();
    // Mark city as untouched to show validation if needed
    this.registrationForm.get('townblock')?.markAsUntouched();
  }

  // DropDown town change
  onSelectTownChange(event: any) {
    //const selectElement = event.target as HTMLSelectElement;
    //const selectedIndex = selectElement.selectedIndex;
    this.townText = event.text;
  }

  // DropDown intervention change
  onSelectInterventionChange(event: any, action: any) {
    if (action == 'select') {
      const selectElement = event.target as HTMLSelectElement;
      const selectedIndex = selectElement.selectedIndex;
      this.interventionText = selectElement.options[selectedIndex].text;
    }
    var selectedValue; //= event.target.value;

    if (action == 'edit')
      selectedValue = event;
    else
      selectedValue = event.target.value;

    var data = { InterventionId: selectedValue, UserId: sessionStorage.getItem('iauserid'), proposalUserId: this.proposalUserId }

    this.apiService.getRequest(API_ENDPOINTS.IA.GETIACOMPONENT, data).subscribe(
      (result: any) => {

        //setTimeout(() => {
        this.typeComponent = result.data;
        this.registrationForm.get('typeComponent')?.markAsUntouched();
        //}, 8000); // Simulate data loading
      },
      error => {
        console.error('Error fetching data:', error);
      }
    );
  }

  // DropDown type of component change
  onSelectTypeOfComponentChange(event: any) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedIndex = selectElement.selectedIndex;
    this.typeOfComponentText = selectElement.options[selectedIndex].text;

    var data = { interventionId: this.registrationForm.get('intervention')?.value, componentId: this.registrationForm.get('typeComponent')?.value }

    this.apiService.getRequest(API_ENDPOINTS.IA.GETSEATINGCAPACITY, data).subscribe(
      (result: any) => {

        this.maxSitingCapacity = result.data[0][0]['seatingCapacity'];
      }
    );

  }

  // DropDown trainer distric change
  onTrainerDistricChange(event: any) {
    
    //const selectElement = event.target as HTMLSelectElement;
    //const selectedIndex = selectElement.selectedIndex;
    this.selectedDistricText = event.text;
    this.selectedDistricId = event.id;

    sessionStorage.setItem('districtText', this.selectedDistricText);

    //var trainerDistId = event.id;
    var data = { DistrictId: event.id }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.DISTRICT.GETCITYBLOCK, data).subscribe(
      (result: any) => {
        
        this.trainerCityData = result.data['item1'];
        this.trainerTownData = result.data['item2'];

      },
      error => {
        console.error('Error fetching data:', error);
      }
    );

  }

  onTrainerDistricEdit(id: any) {
    var data = { DistrictId: id }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.DISTRICT.GETCITYBLOCK, data).subscribe(
      (result: any) => {

        this.trainerCityData = result.data['item1'];
        this.trainerTownData = result.data['item2'];

      },
      error => {
        console.error('Error fetching data:', error);
      }
    );
  }

  // DropDown trainer city change
  onTrainerCityChange(event: any) {
    //const selectElement = event.target as HTMLSelectElement;
    //const selectedIndex = selectElement.selectedIndex;
    this.selectedCityText = event.text;
    this.selectedCityId = event.id;

    sessionStorage.setItem('cityText', this.selectedCityText);

    // Reset city and enable the dropdown
    //this.registrationForm.get('townId')?.setValue('');
    //this.registrationForm.get('townId')?.enable();

    // Mark city as untouched to show validation if needed
    //this.registrationForm.get('townId')?.markAsUntouched();
  }

  // DropDown trainer town change
  onTrainerTownChange(event: any) {

    //const selectElement = event.target as HTMLSelectElement;
    //const selectedIndex = selectElement.selectedIndex;
    this.selectedTownText = event.text;
    this.selectedTownId = event.id;
    sessionStorage.setItem('townText', this.selectedTownText);
  }

  // Method to remove validation from a specific form control
  ignoreNameValidation() {

    const trainerControl = this.registrationForm.get('trainerName');
    const trainerCompanyNameControl = this.registrationForm.get('trainerCompanyName');
    const contactControl = this.registrationForm.get('contactNumber');
    const districControl = this.registrationForm.get('districtId');
    const cityControl = this.registrationForm.get('cityId');
    const townControl = this.registrationForm.get('townId');

    // Remove validators
    trainerControl?.clearValidators();
    trainerCompanyNameControl?.clearValidators();
    contactControl?.clearValidators();
    districControl?.clearValidators();
    cityControl?.clearValidators();
    townControl?.clearValidators();

    // Optionally, you can update the validity of the form control after clearing validators
    trainerControl?.updateValueAndValidity();
    trainerCompanyNameControl?.updateValueAndValidity();
    contactControl?.updateValueAndValidity();
    districControl?.updateValueAndValidity();
    districControl?.updateValueAndValidity();
    cityControl?.updateValueAndValidity();
    townControl?.updateValueAndValidity();

    this.isAdd = false;
  }

  // Method to reset the validation for these controls
  resetValidation() {
    const trainerControl = this.registrationForm.get('trainerName');
    const trainerCompanyNameControl = this.registrationForm.get('trainerCompanyName');
    const contactControl = this.registrationForm.get('contactNumber');
    const districtControl = this.registrationForm.get('districtId');
    const cityControl = this.registrationForm.get('cityId');
    const townControl = this.registrationForm.get('townId');

    //Validators.required,
    //  Validators.pattern(/^([6789]\d{9})$/),
    //  Validators.maxLength(10),

    // Reapply validators (assuming you want to apply "required" as a validator for these controls)
    trainerControl?.setValidators([Validators.required, Validators.maxLength(200), Validators.pattern(this.commonService.stringWithSpacePattern)]);
    trainerCompanyNameControl?.setValidators([Validators.required, Validators.maxLength(200), Validators.pattern(this.commonService.stringWithSpacePattern)]);
    contactControl?.setValidators([Validators.required, Validators.pattern(/^([6789]\d{9})$/), Validators.maxLength(10), Validators.pattern(/^\d{10}$/)]);  // Example validation for a 10-digit number
    districtControl?.setValidators([Validators.required]);
    cityControl?.setValidators([Validators.required]);
    townControl?.setValidators([Validators.required]);

    // Update the validity of the controls after setting the validators
    trainerControl?.updateValueAndValidity();
    trainerCompanyNameControl?.updateValueAndValidity();
    contactControl?.updateValueAndValidity();
    districtControl?.updateValueAndValidity();
    cityControl?.updateValueAndValidity();
    townControl?.updateValueAndValidity();
  }

  // Method to check if the current date is 2 days before the event date
  checkEventDateAndDisableControls() {

    const currentDate = new Date();
    const date = this.eventDate;
    const twoDaysBeforeEvent = new Date(date);
    //twoDaysBeforeEvent.setDate(twoDaysBeforeEvent.getDate() - 2);//final
    twoDaysBeforeEvent.setDate(twoDaysBeforeEvent.getDate());//temp

    // If current date is 2 days or less before the event date, disable the controls
    if (currentDate >= twoDaysBeforeEvent) {
      this.disableAllControls();
    } else {
      this.enableAllControls();
    }
    this.registrationForm.get('intervention')?.disable();
    this.registrationForm.get('typeComponent')?.disable();

    this.registrationForm.get('distric')?.disable();
    this.registrationForm.get('city')?.disable();
    this.registrationForm.get('townblock')?.disable();
    this.registrationForm.get('village')?.disable();

  }

  // Disable all controls in the form
  disableAllControls() {

    Object.keys(this.registrationForm.controls).forEach(key => {
      this.registrationForm.get(key)?.disable();

    });
    this.showButton = false;
    this.isDropdownDisabled = true;

    if (this.txtButton == 'Update') {
      this.registrationForm.get('eventName')?.disable();
      this.registrationForm.get('implementationAgency')?.disable();
    }
  }

  // Enable all controls in the form
  enableAllControls() {

    Object.keys(this.registrationForm.controls).forEach(key => {
      this.registrationForm.get(key)?.enable();
    });
    this.showButton = true;
    if (this.txtButton == 'Update') {
      this.registrationForm.get('eventName')?.disable();
      this.registrationForm.get('implementationAgency')?.disable();
    }
  }

  // Method to update remarks validation based on selected status
  onStatusChange() {

    const selectedStatus = this.registrationForm.get('status')?.value;
    this.updateRemarksValidation(selectedStatus);

    if (selectedStatus == "created") {

      this.registrationForm.get('eventDateTime')?.setValue(this.originalData.eventDateTime);
      this.registrationForm.get('eventStartTime')?.setValue(this.originalData.eventStartTime);
      this.registrationForm.get('durationEvent')?.setValue(this.originalData.durationEvent);
      this.registrationForm.get('period')?.setValue(this.originalData.period);

      this.disableControls();
    } else if (selectedStatus == "postpone") {

      this.registrationForm.get('eventOrganizedBy')?.setValue(this.originalData.eventOrganizedBy);
      this.registrationForm.get('venueDetails')?.setValue(this.originalData.venueDetails);
      //this.registrationForm.get('eventFocusSector')?.setValue(this.originalData.eventFocusSector);
      this.registrationForm.get('sittingCapacity')?.setValue(this.originalData.sittingCapacity);

      this.enableControls();
    } else if (selectedStatus == "cancel") {
      //this.disableAllControls();
      this.disableAllControlsExceptRemark();
    }

  }

  toggleControls(disableControls: string[], enableControls: string[]) {
    disableControls.forEach(control => this.registrationForm.get(control)?.disable());
    enableControls.forEach(control => this.registrationForm.get(control)?.enable());
  }

  // Disable specific controls
  disableControls() {
    this.toggleControls(
      [
        'eventDateTime', 'eventStartTime', 'durationEvent', 'period',
        'distric', 'city', 'townblock', 'village'
      ],
      [
        'eventOrganizedBy', 'venueDetails', 'eventFocusSector', 'sittingCapacity',
        'trainerName', 'trainerCompanyName', 'contactNumber', 'districtId', 'cityId', 'townId'
      ]
    );
    this.isDropdownDisabled = false;
  }

  // Enable specific controls
  enableControls() {
    this.toggleControls(
      [
        'distric', 'city', 'townblock', 'village',
        'eventOrganizedBy', 'venueDetails', 'eventFocusSector', 'sittingCapacity'
      ],
      [
        'eventDateTime', 'eventStartTime', 'durationEvent', 'period',
        'trainerName', 'trainerCompanyName', 'contactNumber', 'districtId', 'cityId', 'townId'
      ]
    );
    this.isDropdownDisabled = false;
  }


  disableAllControlsExceptRemark() {
    Object.keys(this.registrationForm.controls).forEach(controlName => {
      if (controlName !== 'remarks' && controlName !== 'status') {
        this.registrationForm.get(controlName)?.disable();
      } else {
        this.registrationForm.get(controlName)?.enable();
      }
    });
    this.isDropdownDisabled = true;
  }

  //// Disable controls
  //disableControls() {

  //  this.registrationForm.get('eventDateTime')?.disable();
  //  this.registrationForm.get('eventStartTime')?.disable();
  //  this.registrationForm.get('durationEvent')?.disable();
  //  this.registrationForm.get('period')?.disable();

  //  this.registrationForm.get('distric')?.disable();
  //  this.registrationForm.get('city')?.disable();
  //  this.registrationForm.get('townblock')?.disable();
  //  this.registrationForm.get('village')?.disable();

  //  this.registrationForm.get('eventOrganizedBy')?.enable();
  //  this.registrationForm.get('venueDetails')?.enable();
  //  this.registrationForm.get('eventFocusSector')?.enable();
  //  this.registrationForm.get('sittingCapacity')?.enable();

  //  this.registrationForm.get('trainerName')?.enable();
  //  this.registrationForm.get('trainerCompanyName')?.enable();
  //  this.registrationForm.get('contactNumber')?.enable();
  //  this.registrationForm.get('districtId')?.enable();
  //  this.registrationForm.get('cityId')?.enable();
  //  this.registrationForm.get('townId')?.enable();
  //  this.isDropdownDisabled = false;

  //}

  //// Enable controls
  //enableControls() {
  //  this.registrationForm.get('eventDateTime')?.enable();
  //  this.registrationForm.get('eventStartTime')?.enable();
  //  this.registrationForm.get('durationEvent')?.enable();
  //  this.registrationForm.get('period')?.enable();

  //  this.registrationForm.get('distric')?.disable();
  //  this.registrationForm.get('city')?.disable();
  //  this.registrationForm.get('townblock')?.disable();
  //  this.registrationForm.get('village')?.disable();

  //  this.registrationForm.get('eventOrganizedBy')?.disable();
  //  this.registrationForm.get('venueDetails')?.disable();
  //  this.registrationForm.get('eventFocusSector')?.disable();
  //  this.registrationForm.get('sittingCapacity')?.disable();

  //  this.registrationForm.get('trainerName')?.enable();
  //  this.registrationForm.get('trainerCompanyName')?.enable();
  //  this.registrationForm.get('contactNumber')?.enable();
  //  this.registrationForm.get('districtId')?.enable();
  //  this.registrationForm.get('cityId')?.enable();
  //  this.registrationForm.get('townId')?.enable();
  //  this.isDropdownDisabled = false;

  //}

  // Update the required validation for the remarks field based on the status
  private updateRemarksValidation(status: string) {
    const remarksControl = this.registrationForm.get('remarks');

    if (status === 'postpone' || status === 'cancel') {
      // Add 'required' validator if status is 're-schedule' or 'cancel'
      this.isRemarksRequired = true;
      remarksControl?.setValidators([Validators.required, Validators.maxLength(200)]);
    } else {
      // Remove 'required' validator for other statuses
      this.isRemarksRequired = false;
      remarksControl?.clearValidators();
    }

    // Update the validity state after modifying validators
    remarksControl?.updateValueAndValidity();
  }
  // Only text not number
  onKeyPress(event: KeyboardEvent) {
    // Allow only letters and space; block numbers and special characters
    const regex = /^[A-Za-z ]*$/;
    if (!regex.test(event.key)) {
      event.preventDefault();  // Prevent non-alphabet input
    }
  }

  onTimeChange(event: Event) {

    const input = event.target as HTMLInputElement;
    const time = input.value; // Raw time in HH:mm format
    if (time) {
      // Convert the time to a Date object
      const [hours, minutes] = time.split(':').map(Number);
      const date = new Date();
      date.setHours(hours, minutes);

      // Format the time using DatePipe
      this.formattedTime = this.datePipe.transform(date, 'hh:mm a'); // Example: 03:45 PM
    } else {
      this.formattedTime = null;
    }

    this.registrationForm.get('durationEvent')?.reset(); // Reset the form control
    this.removeOptions();

  }

  resetTimeStatus() {
    this.removeOptions();
  }

  // Save and Update data in database
  onSubmit() {

    this.isSubmitted = true;

    const statusControl = this.registrationForm.get('status');
    if (this.txtButton == "Update") {
      this.ignoreNameValidation();
      statusControl?.setValidators([Validators.required]);
    } else {
      // Remove the required validation when the condition is false
      statusControl?.clearValidators();

    }
    statusControl?.updateValueAndValidity();

    if (this.trainerData.length == 0 && (this.registrationForm.get('trainerName')?.value || this.txtButton == "Submit"))
      this.resetValidation();
    else
      this.ignoreNameValidation();


    if (this.registrationForm.valid) {

      var spoc = this.registrationForm.get('spoc')?.value;
      const selectedIds = spoc.map((item: any) => item.id).join(',');

      if (this.trainerData.length == 0) {
        this.toastrService.error("error", 'Add atleat one trainer.');
        return;
      }

      this.data = {
        eventId: this.UniqueEventId,
        proposalUserId: this.proposalUserId,
        eventOrganizedById: this.registrationForm.get('eventOrganizedBy')?.value,
        implementationAgency: sessionStorage.getItem("iauserid"),
        eventName: this.registrationForm.get('eventName')?.value,
        eventDate: this.datePipe.transform(this.registrationForm.get('eventDateTime')?.value || 'yyyy-MM-dd'),
        eventTime: this.registrationForm.get('eventStartTime')?.value,
        eventDuration: this.registrationForm.get('durationEvent')?.value,
        period: this.registrationForm.get('period')?.value,
        districtId: String(this.registrationForm.get('distric')?.value),
        districName: this.districText,
        cityId: String(this.registrationForm.get('city')?.value),
        cityName: this.cityText,
        townId: String(this.registrationForm.get('townblock')?.value),
        townName: this.townText,
        village: this.registrationForm.get('village')?.value,
        venueDetails: this.registrationForm.get('venueDetails')?.value,
        numberofParticipants: this.registrationForm.get('sittingCapacity')?.value,
        eventFocusSectorId: String(this.registrationForm.get('eventFocusSector')?.value),
        interventionId: this.registrationForm.get('intervention')?.value,
        interventionName: this.interventionText,
        componentId: String(this.registrationForm.get('typeComponent')?.value),
        componentName: this.typeOfComponentText,
        SPOCId: selectedIds,
        status: this.registrationForm.get('status')?.value ?? "created",
        remarks: this.registrationForm.get('remarks')?.value,
        eventOriginalDate: this.eventOriginalDate,
        trainerDetails: this.trainerData
      }
      this.message = this.data.status;

      this.apiService.postRequest(API_ENDPOINTS.IA.POSTEVENTCREATION, this.data).subscribe(
        (result: any) => {


          if (this.message == "created")
            this.toastrService.success('Event details have been added successfully!', 'Success');
          else if (this.message == "postpone")
            this.toastrService.success('The event date has been postponed successfully!', 'Success');
          else
            this.toastrService.success('The event has been successfully cancelled!', 'Success');

          this.router.navigate(['/view_event']);
        },
        error => {
          this.toastrService.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
          //console.error('Error saving data:', error);
        }
      );
    }

  }

  onBack() {
    this.router.navigate(['/view_event']);
  }

  setMinTime() {

    this.resetTime();
    var eventDt = this.eventDateTime;
    var now = new Date();

    if (this.isSameDate(eventDt, now)) {
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      this.minTime = `${hours}:${minutes}`;
    } else {
      const hours = String(eventDt.getHours()).padStart(2, '0');
      const minutes = String(eventDt.getMinutes()).padStart(2, '0');
      this.minTime = `${hours}:${minutes}`;
    }


    //const eventDate = this.registrationForm.get('eventDateTime')?.value;

    //const dateString = '28-02-2025'; // Format: DD-MM-YYYY
    //const [day, month, year] = dateString.split('-').map(Number);

    //// Create a Date object — months are zero-indexed (0 = Jan, 1 = Feb, ...)
    //const date = new Date(year, month - 1, day);



    ////const now = new Date('2025-02-28');
    //const hours = String(date.getHours()).padStart(2, '0');
    //const minutes = String(date.getMinutes()).padStart(2, '0');
    //this.minTime = `${hours}:${minutes}`;
  }

  // method to check if two dates have the same year, month, and day
  isSameDate(d1: Date, d2: Date): boolean {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  resetTime() {
    const eventStartTimeControl = this.registrationForm.get('eventStartTime');
    eventStartTimeControl?.reset();
    eventStartTimeControl?.setErrors(null); // Clears any validation errors
  }

  onBlur(controlName: string) {
    const trimmedText = this.registrationForm.get(controlName)?.value.trim().replace(/\s+/g, ' ') || '';
    this.registrationForm.get(controlName)?.setValue(trimmedText);
  }

  //=====================================================

  updateData(updatedItem: { id: string, trainerName: string, trainerCompanyName: string }) {
    // Find the item by its id
    const item = this.trainerData.find((item: any) => item.id === updatedItem.id);

    if (item) {
      // Update the found item
      item.name = updatedItem.trainerName;
      item.age = updatedItem.trainerCompanyName;
    }
  }

  //onPreview() {
  //  this.isSubmitted = true;

  //  if (this.registrationForm.valid) {
  //    this.data = {
  //      eventOrganizedById: this.registrationForm.get('eventOrganizedBy')?.value,
  //      implementationAgencyName: this.implementationAgencyName,
  //      eventOrganizedByText: this.eventOrganizationText,
  //      implementationAgency: sessionStorage.getItem("iauserid"),
  //      eventName: this.registrationForm.get('eventName')?.value,
  //      eventDateTime: this.registrationForm.get('eventDateTime')?.value,
  //      eventDuration: this.registrationForm.get('durationEvent')?.value,
  //      period: this.registrationForm.get('period')?.value,
  //      districtId: this.registrationForm.get('distric')?.value,
  //      districtText: this.districText,
  //      cityId: this.registrationForm.get('city')?.value,
  //      cityText: this.cityText,
  //      townId: this.registrationForm.get('townblock')?.value,
  //      townText: this.townText,
  //      village: this.registrationForm.get('village')?.value,
  //      venueDetails: this.registrationForm.get('venueDetails')?.value,
  //      numberofParticipants: this.registrationForm.get('sittingCapacity')?.value,
  //      eventFocusSectorId: this.registrationForm.get('eventFocusSector')?.value,
  //      eventFocusSectorText: this.eventFocusText,
  //      interventionId: this.registrationForm.get('intervention')?.value,
  //      interventionText: this.interventionText,
  //      componentId: this.registrationForm.get('typeComponent')?.value,
  //      componentText: this.typeOfComponentText,
  //      trainerDetails: this.trainerData,
  //      spocDetails: this.spocData,
  //    }
  //    //this.isFieldVisible = false;
  //    //this.isPreviewVisible = true;

  //    //this.router.navigate(['/iacreatepreview'], { state: { formData: data } });
  //  } else {
  //    this.registrationForm.markAllAsTouched();
  //    return;
  //  }
  //}

  //onEdit() {
  //  this.isFieldVisible = true;
  //  this.isPreviewVisible = false;
  //}

  //async onSelectDistricChange(e: any, action: any): Promise<void> {
  //  var stateId;
  //  if (action == 'edit')
  //    stateId = e;
  //  else
  //    stateId = e.target.value;
  //  try {
  //    const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.DISTRICT.GETDISTRICTBASEDONSTATE, { StateID: stateId }).toPromise();
  //    if (data.data && Array.isArray(data.data)) {
  //
  //      this.districtsBasedOnState = data.data;
  //    } else {
  //      console.error('Unexpected data structure:', data);
  //    }
  //  } catch (error) {
  //    console.error('Error fetching interests:', error); // Handle error
  //  }
  //}

  //onSOCDeSelect(item: any) {

  //  var text = item.text;
  //  // Find the index of the object with id 4
  //  const index = this.spocData.findIndex((item: any) => item.text === text);

  //  if (index !== -1) {
  //    // Remove the item at the found index
  //    this.spocData.splice(index, 1);
  //  }

  //  if (this.spocData.length == 0)
  //    this.visibleSPOCTable = false;

  //}

  onDateSelect(date: NgbDateStruct): void {
    const formattedDate = `${date.day.toString().padStart(2, '0')}/${date.month
      .toString()
      .padStart(2, '0')}/${date.year}`;
    this.registrationForm.controls['eventDate'].setValue(formattedDate);
  }
}

